__turbopack_context__.v({
  "tooltip": "MDAXIa_tooltip",
});
